import React from "react";
import TablePagination from '@mui/material/TablePagination';
import CoreTablePagination from "@mui/material/TablePagination";

// Re-usable pagination component for our codebase
const Paginate = ({ totalRowCount, page, rowsPerPage, handleChange, handleChangeRowsPerPage, showCorePaginate, rowsPerPageOptions }) => {
    
    var lRowsPerPageOptions = rowsPerPageOptions;
    if(!lRowsPerPageOptions) 
    {
      lRowsPerPageOptions = showCorePaginate ? [rowsPerPage] : rowsPerPageOptions ?? [rowsPerPage, rowsPerPage*2, { value: -1, label: 'All' }]
    }

    return (
    <div>
      {showCorePaginate ? (
        <CoreTablePagination
          style={{
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={lRowsPerPageOptions}
          page={page}
          onPageChange={handleChange}
        >
        </CoreTablePagination> 
      ) : (
        <TablePagination
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={lRowsPerPageOptions}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page}
          onPageChange={handleChange}
          showFirstButton={true}
          showLastButton={true}
          sx={{
            ".MuiTablePagination-selectLabel":{
              color:"#6acde6"
            },
            ".MuiTablePagination-displayedRows":{
              color:"#6acde6"
            },
            ".MuiTablePagination-select":{
              color:"#6acde6"
            }
          }}
        />
      )}
    </div>
  );
};

export default Paginate;
